import request from '@/utils/request'
import { resolve } from 'path-browserify'

export function login(data) {
  return request({
    url: '/jiqiren/login',
    method: 'post',
    data,
  })
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token },
  })
}

export function logout(username) {
  return request({
    url: `/jiqiren/login/${username}`,
    method: 'DELETE',
  })
}

export function fetchRoleMenu() {
  // return request({
  //   url: '/user/info',
  //   method: 'get',
  //   params: {},
  // })
  return new Promise((resolve) => {
    resolve({ result: 'true', data: { menuIdent: [] } })
  })
}
